import {} from "vue";
import { useUserLocalStorage } from "./userLocalStorage";
export function usePersistentToggle(uniqueId) {
    const localStorageKey = `toggle-state-${uniqueId}`;
    const toggled = useUserLocalStorage(localStorageKey, false);
    // Expose a function for toggling state
    const toggle = () => {
        toggled.value = !toggled.value;
    };
    return {
        toggled,
        toggle,
    };
}
